import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';

import PasswordResetForm from './PasswordResetForm';
import PasswordResetSuccess from './PasswordResetSuccess';
import PasswordResetRequestForm from './PasswordResetRequestForm';
import PasswordResetRequestSuccess from './PasswordResetRequestSuccess';

function PasswordReset() {
  const { path: basePath } = useRouteMatch();
  // this doesn't work with our setup for some reason -> const Subroute = ({ path, ...rest }) => <Route path={`${basePath}${path}`} {...rest} />; // eslint-disable-line
  const getFullPath = (path) => `${basePath}${path}`;
  return (
    <Switch>
      <Route
        path={getFullPath('/')}
        exact
        component={PasswordResetRequestForm}
      />
      <Route
        path={getFullPath('/done')}
        component={PasswordResetRequestSuccess}
      />
      <Route path={getFullPath('/complete')} component={PasswordResetSuccess} />
      <Route path={getFullPath('/:uid/:path')} component={PasswordResetForm} />
    </Switch>
  );
}

export default PasswordReset;
